import { useSuspenseQuery } from '@tanstack/react-query';

import { getChapterValidationHistoryOptions } from '@/module/Author/Chapter/Validation/model/ChapterValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface ChapterValidationHistoryProps {
  chapterId: Id;
}

export function ChapterValidationHistory({ chapterId }: ChapterValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getChapterValidationHistoryOptions(chapterId));

  return <ValidationHistoryContent history={history} />;
}
